$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  const location_id = $("body").attr("event_id");

  if (p === "customer" && a === "list") {
    let order_by = "first_name";
    let order_by_direction = "asc";

    $(document).on("click", ".pagination a", function (e) {
      e.preventDefault();

      let page = parseInt($(this).attr("href").substring(6));
      let search_string = $("#search_string").val();

      getCustomerList(
        location_id,
        page,
        order_by,
        order_by_direction,
        search_string
      );
    });

    $(document).on("click", ".sort", function (e) {
      e.preventDefault();
      let page = $("#customer-table").attr("data-current-page");

      let search_string = $("#search_string").val();
      order_by = $(this).attr("data-order-by");
      order_by_direction = $(this).attr("data-order-by-direction");

      getCustomerList(
        location_id,
        page,
        order_by,
        order_by_direction,
        search_string
      );
    });

    function getCustomerList(
      location_id = null,
      page = 1,
      order_by,
      order_by_direction,
      search_string = ""
    ) {
      $.ajax({
        type: "POST",
        url: "/ajax/customer/search",
        data: {
          location_id,
          page,
          search_string,
          order_by,
          order_by_direction,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $("#customer-list-container").empty();
            $("#customer-list-container").append(data.html);
          }

          $("html,body").scrollTop(0);
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }
  }
});
